import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { setupOpenApi } from '@/api/setupOpenApi';
import { Providers } from './providers';
import { router } from './routes';

import './global.css';

setupOpenApi();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
